import React, { useState, useEffect } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import FeedBanner from './FeedBanner'
import categories from '../../data/categories'
import FeedCard from '../../components/ImageCard'
import { fetchFeedEntries } from '../../lib/contentful'

const FeedPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [feedItems, setFeedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true
    async function load() {
      setLoading(true)
      try {
        const entries = await fetchFeedEntries().catch((e) => {
          // if contentful not configured, just return null
          console.warn('Contentful fetch failed:', e.message)
          return null
        })

        console.log('Fetched feed entries:', entries);
        if (!mounted) return
        if (entries && entries.length) {
          setFeedItems(entries)
        } else {
          setFeedItems([]);
        }
      } catch (e) {
        console.error(e)
        setError('Failed to load feed')
      } finally {
        if (mounted) setLoading(false)
      }
    }
    load()
    return () => { mounted = false }
  }, [])

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId === selectedCategory ? "all" : categoryId);
  };

  // helper to determine if an item matches the currently selected category
  const matchesCategory = (item) => {
    if (selectedCategory === 'all' || !selectedCategory) return true;
    if (Array.isArray(item.category) && item.category.length) {
      return item.category.includes(selectedCategory)
    }
    return [item.type, item.brand, item.slug, item.id].includes(selectedCategory);
  }

  const filteredItems = Array.isArray(feedItems) ? feedItems.filter(matchesCategory) : []

  return (
    <div className="page pt-20">
      <Navbar />
      <FeedBanner />
        <div className="px-10 py-12">
           <div>
            <div className="flex flex-wrap gap-3">
                {categories.map((category) => {
                  // compute count: number of feedItems that include this category id
                  const count = Array.isArray(feedItems)
                    ? feedItems.reduce((acc, it) => {
                        if (Array.isArray(it.category) && it.category.includes(category.id)) return acc + 1
                        return acc
                      }, 0)
                    : 0

                  return (
                    <button
                      key={category.id}
                      onClick={() => handleCategoryClick(category.id)}
                      className={`rounded-full border-neutral-600 px-4 py-2 border text-sm font-medium cursor-pointer w-fit transition-all ${
                        selectedCategory === category.id
                          ? 'bg-neutral-800 text-[#e3eed1cc] border-[#e3eed1cc] '
                          : 'text-[#ECF2E1] bg-none hover:bg-neutral-800 hover:text-white'
                      }`}
                      title={category.description}
                    >
                      {category.name} {count > 0 ? `(${count})` : ''}
                    </button>
                  )
                })}
            </div>
            
           </div> 
           <div className="mt-5">
            {/* Feed content goes here, filtered by selectedCategory */}
            <p className="text-neutral-400 font-medium text-sm">{selectedCategory ? (categories.find(cat => cat.id === selectedCategory)?.description ?? 'All') : 'All'}</p>
            <div className="mt-10">
              {loading && (
                      <div className="py-10 px-10 pt-0">
                        <div className="flex items-center justify-center h-48">
                          <svg className="w-8 h-8 text-neutral-500 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                          </svg>
                          <span className="ml-3 text-neutral-500">Loading feed...</span>
                        </div>
                      </div>
              )}
              {error && <p className="text-sm text-red-400">{error}</p>}
              { /* If no items after filtering, show an empty state */ }
              {(!loading && filteredItems.length === 0) ? (
                <div className="py-12 text-left col-span-full">
                  <p className="text-neutral-400 font-medium text-lg">Check back soon</p>
                  <p className="text-neutral-500 text-sm mt-2">There are no items in the <span className="font-semibold">{selectedCategory === 'all' ? 'feed' : (categories.find(c=>c.id===selectedCategory)?.name || selectedCategory)}</span> category right now.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredItems.map((item, idx) => {
                    const imageUrl = item.coverImage || (Array.isArray(item.media) ? item.media[0] : undefined) || item.image
                    const descr = item.summary || item.impact || ''
                    // Pass startDate/endDate if present, fallback to legacy date
                    return (
                      <FeedCard
                        key={item.slug || item.id || idx}
                        title={item.title}
                        description={descr}
                        image={imageUrl}
                        imageAlt={item.title}
                        startDate={item.startDate}
                        endDate={item.endDate}
                      />
                    )
                  })}
                </div>
              )}
            </div>
           </div>
        </div>
        {/* Upcoming  */}
      <Footer/>
    </div>
  )
}

export default FeedPage

// load contentful entries client-side and merge with local fallback
// useEffect placed after export to keep top of file compact
